import Login, { DispatchFromProps, LoginProps, StateFromProps } from './Login';
import { Store, connect } from '../rootReducer';
import { attemptLogin, attemptOpenIdLogin } from './LoginAction';
import { closeModal, openModal, showErrorModal } from '../appActions';

import { ModalWrapperProps } from '../Modal/ModalWrapper';
import { OpenIDConnectConfig } from '@pdcplan/shared/utils/OpenID';
import { ThunkDispatch } from '../types';

const mapStateToProps = (store: Store): StateFromProps => ({
  errorMessage: store.loginReducer.errorMessage,
  version: store.appReducer.version,
  openModals: store.appReducer.openModals,
  modalLoading: store.appReducer.modalLoading,
  loginType: store.appReducer.globalSettings.logonMethod,
  attemptingLogin: store.loginReducer.attemptingLogin,
  loadingGetSettings: store.appReducer.loadingGetSettings,
  loadingGetVersion: store.appReducer.loadingGetVersion,
  hasInternet: store.appReducer.hasInternet,
  connectionError: store.appReducer.connectionError,
  globalSettings: store.appReducer.globalSettings,
});

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchFromProps => ({
  attemptLogin: (username: string, password: string) => {
    void dispatch(attemptLogin(username, password));
  },
  attemptOpenIdLogin: (settings: OpenIDConnectConfig) =>
    dispatch(attemptOpenIdLogin(settings)),
  openModal: (modal: ModalWrapperProps) => {
    dispatch(openModal(modal));
  },
  closeModal: () => dispatch(closeModal()),
  showErrorModal: (errorInfo?: {
    error?: Error | null;
    title?: string;
    isConnectionError?: boolean;
  }) =>
    dispatch(
      showErrorModal(
        errorInfo?.error,
        errorInfo?.title,
        errorInfo?.isConnectionError
      )
    ),
});

export default connect<StateFromProps, DispatchFromProps, LoginProps>(
  mapStateToProps,
  mapDispatchToProps
)(Login);
